module.exports = __webpack_public_path__ + "img/send-sms-token.c9f3ec62.svg";